// import { useState } from "react";
import { useState } from "react";
import "./inpt.css";

export default function Inpt(props) {
  // console.log("Inpt props", props);

  const [valOnClick, setValOnClick] = useState(false);

  // props.className || null
  var labelClass = "";
  if (props.className && props.required)
    labelClass = props.className + " required";
  else if (props.className) labelClass = props.className;
  else if (props.required) labelClass = "required";
  else labelClass = null; //clasName is not shown, with "" className is shown

  // var labelGroupClasses = classNames(
  //   'btn-group',
  //   'pull-right',
  //   {
  //     'show': this.props.showBulkActions,
  //     'hidden': !this.props.showBulkActions
  //   }
  // );

  return (
    <>
      <label className={labelClass}>{props.label}:</label>
      {/* <div className={props.required ? "required" : null}> */}
      <input
        name={props.name}
        // value={valOnClick ? valOnClick : props.val}
        value={props.val}
        type={props.type}
        placeholder={props.placeholder}
        onChange={(e) => {
          props.onChg(e);
          setValOnClick(e.target.value);
        }}
        className={props.val ? "filledInput" : null}
      />
      {/* {props.required && <span>*</span>} */}
      {/* </div> */}
      {props.showSetBtn && (
        // <span className="setBtn" onClick={(props.val = props.placeholder)}>{props.showSetBtn} 100%</span>
        <span
          className="setBtn"
          // TODO: вместо setValOnClick нужно пробрасывать наверх props.onChg(e)
          // name={props.name}
          // value={props.placeholder}
          // data-onclick-val={{ name: props.name, val: props.placeholder }}
          onClick={(e) => {
            // setValOnClick(props.placeholder);
            // console.log("click", evt.target.name, evt.target.value, evt);
            props.onChg(e, { name: props.name, value: props.placeholder });
          }}
        >
          {props.showSetBtn + " " + props.placeholder}
        </span>
      )}
    </>
  );
}
